module.exports = __webpack_public_path__ + "img/bdsjh.b5c44f2b.png";